import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button/Button';
import Utils from '../../Common/Utils';
import { createLeadSource } from './Actions';
import { CREATE_LEAD_SOURCE_BUTTON_NAME } from './Constants';

const CreateLeadSourceDialogContent = ({ onCancel, onSave, leadSourceName }) => {
  const [name, setName] = useState(leadSourceName);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleChange = ({ target: { value } }) => {
    setError(null);
    setName(value);
  };

  const handleSave = () => {
    setLoading(true);
    dispatch(createLeadSource(name))
      .then((res) => onSave(res))
      .catch((e) => {
        setLoading(false);
        setError(Utils.parseErrorMessage(e));
      });
  };

  return (
    <>
      <DialogContent>
        <TextField
          fullWidth
          autoFocus
          label="Lead source"
          value={name}
          onChange={handleChange}
          error={!!error}
          helperText={error || ' '}
          disabled={loading}
          data-testid="create-lead-source-field"
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={!name || !!error}
          loading={loading}
          onClick={handleSave}
        >
          {CREATE_LEAD_SOURCE_BUTTON_NAME}
        </Button>
      </DialogActions>
    </>
  );
};

CreateLeadSourceDialogContent.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  leadSourceName: PropTypes.string,
};

CreateLeadSourceDialogContent.defaultProps = {
  leadSourceName: '',
};

export default CreateLeadSourceDialogContent;
